/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_ActionsInputs */

const en_ui_trips_actions = /** @type {(inputs: Ui_Trips_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trip actions`)
};

const de_ui_trips_actions = /** @type {(inputs: Ui_Trips_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tour-Aktionen`)
};

/**
* | output |
* | --- |
* | "Trip actions" |
*
* @param {Ui_Trips_ActionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_actions = /** @type {((inputs?: Ui_Trips_ActionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_ActionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_actions(inputs)
	return de_ui_trips_actions(inputs)
});